import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Heading, Flex, Box } from 'roo-ui/components';
import RatingFilterElement from 'components/Filters/Search/RatingFilter/RatingFilterElement/RatingFilterElement';
import FilterContainer from 'components/Filters/FilterContainer';
import TextButton from 'components/TextButton';
import { getQueryMinStarRating } from 'store/search/searchSelectors/querySelectors';

const RATING_TYPE = 'minStarRating';

const StarRatingFilter = ({ onChange, displayClearFilter, onClearFilter }) => {
  const minStarRating = useSelector(getQueryMinStarRating);

  return (
    <Fragment>
      <Flex justifyContent="space-between">
        <Heading.h3 fontSize="sm">Hotel Rating</Heading.h3>
        {displayClearFilter && (
          <Box>
            <TextButton data-testid="clear-star-button" fontSize="sm" color="brand.primary" onClick={onClearFilter}>
              Clear
            </TextButton>
          </Box>
        )}
      </Flex>
      <Box mb={[0, displayClearFilter ? 0 : 6]}>
        <FilterContainer data-testid="hotel-rating-filter">
          <RatingFilterElement
            text="5 out of 5 rating"
            rating="5"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="4 out of 5 rating & up"
            rating="4"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="3 out of 5 rating & up"
            rating="3"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="All ratings"
            currentRating={minStarRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
        </FilterContainer>
      </Box>
    </Fragment>
  );
};

StarRatingFilter.propTypes = {
  minStarRating: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

StarRatingFilter.defaultProps = {
  minStarRating: undefined,
  displayClearFilter: false,
  onClearFilter: () => {},
};

export default StarRatingFilter;
